import axios from 'axios';

const host = window.location.hostname;  
// will be:
// localhost → on your system
// 192.168.0.57 → on other systems

export const API = axios.create({
  baseURL: `http://${host}:5000/api`,
  withCredentials: true
});

export const BASE_URL = `http://${host}:5000`;